import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import Resource from "./Resource";
import { Copy, IconCopy } from "~/components";
import { formatAddress } from "~/utils";
import { hapticFeedback } from "@telegram-apps/sdk-react";
import { isBuiltInToken } from "~/pages/Trade/utils";

export default function KDetailTokenAbout({ info, contract }: any) {
    const { t } = useTranslation();

    return (
        <Fragment>
            <div>
                <div className="mt-[16px]">
                    <div className="flex items-center text-h4 font-Semibold text-text_1 h-[32px]">
                        {t("about")}
                    </div>
                    {!isBuiltInToken(contract) && (
                        <Copy
                            copyText={contract}
                            customSlot
                            onCopy={() =>
                                hapticFeedback.notificationOccurred("success")
                            }
                        >
                            <div className="w-full h-[44px] flex  px-[12px] items-center  justify-between text-text_1 font-Regular  mt-[12px] border-[0.5px] border-border_2 rounded-[12px] text-body2 cursor-pointer">
                                <div>{t("contract")}</div>
                                <div className="flex items-center">
                                    <div>{formatAddress(contract)}</div>
                                    <IconCopy className=" text-[18px]  ml-[4px]" />
                                </div>
                            </div>
                        </Copy>
                    )}
                    {info.about && (
                        <div className="w-full text-body3 font-Regular text-text_2 mt-[12px]">
                            {info.about}
                        </div>
                    )}
                </div>
                <Resource info={info} />
            </div>
        </Fragment>
    );
}
